const socketIo = require('socket.io-client');
const { reactRender } = require('./reactRender');

let io = socketIo.connect();

io.on('disconnect', function(reason) { 
	console.log("io.on('disconnected', function() { ", reason);
	reactRender.showAlert("Disconnected from the server.  Please refresh the page.", true); 
	reactRender.isDisconnected = true;
});

io.on('reconnect', function() { 
	console.log("io.on('reconnect', function() { ");
	reactRender.showAlert("Disconnected from the server.  Please refresh the page.", true); 
	reactRender.isDisconnected = true;
});

io.on('reconnectGood', function() { 
	console.log("reconnectGood");
	reactRender.showAlert(""); 
	reactRender.isDisconnected = false;
});

io.on('error', function(error) { 
	console.log("error", error);
	reactRender.showAlert("error", true); 
	reactRender.isDisconnected = false;
});

io.on('reset', function() { 
	
	console.log("reconnectGood");
	reactRender.showAlert("Disconnected from the server.  Please refresh the page.", true); 
	reactRender.isDisconnected = true;
	window.reload();
});

module.exports = { io };
